class BsaleWebhookClient {

  constructor(lp_access_token) {
    this.lp_access_token = lp_access_token;
  }

  async request(path, body) {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${path}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.lp_access_token
        },
        body: JSON.stringify(body)
      }
    );

    return await response.json();
  }

  login(email, password) {
    return this.request('/bsale/webhook/login', { email, password });
  }

  status(access_token_bsale, cookie, webhook_url) {
    return this.request(
      '/bsale/webhook/status',
      { access_token_bsale, cookie, webhook_url }
    );
  }

  register(access_token_bsale, cookie, webhook_url) {
    return this.request(
      '/bsale/webhook/register',
      { access_token_bsale, cookie, webhook_url }
    );
  }
}

export default BsaleWebhookClient;
